import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getImmobilizationSelector } from '../selectors'
import { ImmobilizationConstants } from '../store/immobilization.constants'
import { IImmobilizationState } from '../store/immobilization.types'

export function* setSite() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const immobilizationState: IImmobilizationState = yield select(getImmobilizationSelector)
  const { inputRows } = procedureState
  const { site } = immobilizationState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === ImmobilizationConstants.SET_SITE) {
        //@ts-ignore
        input.props.savedValues = site
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setSiteSaga() {
  yield takeLatest([ImmobilizationConstants.SET_SITE], setSite)
}
